module.exports = __webpack_public_path__ + "static/media/graph-low-label.01f04142.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/graph-low-label.svg
// module id = 251
// module chunks = 0